import { render, staticRenderFns } from "./vsSwitch.vue?vue&type=template&id=b82d5bd0&lang=html&"
import script from "./vsSwitch.vue?vue&type=script&lang=js&"
export * from "./vsSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsSwitch.vue"
export default component.exports